import React, { createContext, useContext } from 'react';
import createBankFileService from '../bankFile.service';

const BankFileServiceContext = createContext();

export const BankFileServiceProvider = ({ children }) => {
  const bankFileService = createBankFileService();
  
  return (
    <BankFileServiceContext.Provider value={bankFileService}>
      {children}
    </BankFileServiceContext.Provider>
  );
};

export const useBankFileService = () => {
  const context = useContext(BankFileServiceContext);
  if (context === undefined) {
    throw new Error('useBankFileService must be used within a BankFileServiceProvider');
  }
  return context;
};

export default BankFileServiceContext;
